export default __webpack_public_path__ + "e5c3880a92e1b74a64c427ef950ea2be.png";